import React, { Component } from "react";
import './ConversationStyleSheet.css';
import PreviewAttachmentFiles from "./PreviewAttachmentFiles";
import { debounce } from 'lodash';
import ActivityIndicator from "../CommonUtils/ActivityIndicator";

class InputBox extends Component {

    constructor(props) {
        super(props);
        this.messageRef = React.createRef();
        this.file = React.createRef();
        this.state = { 
            previewFiles: [],
            isLoading:false
        }
    }

    defaultMessage = "Type a message..."

    render() {
        return (
            <>
                <div className="s360-conversation-input-box-container" style={{ height: "60px" }}>
                    <div className="s360-input-box-attachment" onClick={() => this.file.current.click()}>
                        <input style={{ opacity: "0", width: '1px', display: "none" }} ref={this.file} type="file" multiple="multiple" onChange={this.onFileSelect} className="UploadFile image_uploader" />
                        {this.attachmentSVGImage(this.props.config.designDetails.headerColor)}
                    </div>
                    <div className="s360-input-box-input-container" style={this.containerStyle()} >
                        <input ref={this.messageRef} className="s360-input-box-input" onfo defaultValue={this.defaultMessage} onBlur={this.onInputOut} onClick={this.onClickInput} type="text" onChange={this.onTextFieldChange}  style={this.containerStyle()} onKeyPress={this.handleKeyPress} />
                    </div>
                    <div className="s360-input-box-send" onClick={this.onMessageSend}>
                        {this.sendSVGImage(this.props.config.designDetails.headerColor)}
                    </div>
                </div>
                {(this.state.previewFiles.length > 0) && <PreviewAttachmentFiles {...this.props} {...this.state} onRemovePreviewFile={this.onRemovePreviewFile}  files={this.state.previewFiles} />}
            </>
        )
    }

    containerStyle = () => {
        return {
            borderColor:     this.props.config.designDetails.headerColor,
            color:           this.props.config.designDetails.headerColor,
            backgroundColor: this.props.config.designDetails.pageBackgroundColor
        }
    }

    onClickInput = (e) => {
        if (e.target.value === this.defaultMessage) { this.messageRef.current.value = ""; }
    }

    onInputOut = (e) => {
        if (!e.target.value || !e.target.value.trim) { this.messageRef.current.value = this.defaultMessage; }
    }

    currentTypingStatus = false;
    onTextFieldChange = () => {
        if (this.currentTypingStatus === false) {
            this.props.sendTypingStatus(true);
        }
        this.currentTypingStatus = true;
        this.debouncedTextChange();
    }

    debouncedTextChange = debounce(() => {
        if (this.currentTypingStatus === true) {
            this.props.sendTypingStatus(false);
        }
        this.currentTypingStatus = false;
    }, 1000)

    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            // console.log('enter press here! ')
            event.preventDefault();
            this.onMessageSend();
        }
    }

    // MARK: On Send Button Click.
    onMessageSend = () => {
        let isMediaAttached = (this.state.previewFiles || []).length !== 0;
        let hasTextMessage  = !(!this.messageRef.current.value || !this.messageRef.current.value.trim() || this.messageRef.current.value === this.defaultMessage);
        if (!isMediaAttached && !hasTextMessage) { return }
        if (hasTextMessage && !isMediaAttached) {
            this.props.sendMessage(this.messageRef.current.value.trim());
        } else if (isMediaAttached) {
            let textMessage = hasTextMessage ? this.messageRef.current.value.trim() : null;
            this.setState({ isLoading: true }, () => {
                this.props.sendMessageWithAttachemnts(this.state.previewFiles, textMessage)
                          .finally(() => { this.setState({ isLoading: false, previewFiles: [] }); });
            });
        }
        this.messageRef.current.value = "";
    }

    //MARK: Attachments
    onFileSelect = (e) => {
        if (e.target.files) {
            const filesToUpload = [];
            let files = e.target.files;
            for (var i = 0; i < files.length; i++) { filesToUpload.push(files[i]); }
            if (filesToUpload.length === 0) { return }
            this.setState({ previewFiles: filesToUpload });
        }
    }

    attachmentSVGImage = (imageColor, width, height) => {
        return <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
            // width={width || "100%"} height={height || "100%"}
            viewBox="0 0 172 172"
            style={{ fill: imageColor }}><g transform="translate(-17.2,-17.2) scale(1.2,1.2)"><g fill="none" fillRule="nonzero" stroke="none" strokeWidth="1" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeDasharray="" strokeDashoffset="0" fontFamily="none" fontWeight="none" fontSize="none" textAnchor="none" style={{ mixBlendMode: "normal" }}><path d="M0,172v-172h172v172z" fill="none"></path><g fill={imageColor}><path d="M61.2965,154.06183c-11.11908,0 -22.24175,-4.2355 -30.702,-12.71008c-16.84883,-16.8775 -15.90642,-45.39008 0.95675,-62.25325l50.61817,-50.61817c5.96267,-5.96267 13.7815,-9.97242 22.19875,-10.49558c9.67142,-0.602 18.86625,2.88817 25.64233,9.67142c6.78325,6.77967 10.27342,15.9745 9.67142,25.64233c-0.52317,8.41367 -4.5365,16.23608 -10.49558,22.19875l-49.708,49.708c-4.00617,4.00617 -9.20558,6.79042 -14.84575,7.28492c-6.95167,0.60917 -13.588,-1.82033 -18.44342,-6.67933c-4.859,-4.85542 -7.2885,-11.49175 -6.67933,-18.44342c0.4945,-5.64017 3.27875,-10.84317 7.28492,-14.84575l34.64725,-34.64367c0.69875,-0.69875 1.83467,-0.69875 2.53342,0l5.06683,5.06683c0.69875,0.69875 0.69875,1.83467 0,2.53342l-34.93033,34.93033c-1.85258,1.85258 -3.27158,4.17458 -3.73383,6.75458c-0.74533,4.14233 0.54108,8.17717 3.41492,11.051c4.66908,4.66908 12.80325,4.67625 17.48308,0l51.13775,-51.13775c4.24625,-4.257 6.58617,-9.90433 6.58617,-15.91358c0,-6.00925 -2.33992,-11.66017 -6.58975,-15.90642c-4.24983,-4.24625 -9.90075,-6.58975 -15.90642,-6.58975c-6.00567,0 -11.65658,2.33992 -15.90642,6.58975l-52.374,52.37042c-12.72083,12.72442 -12.72083,33.42533 0,46.14975c12.728,12.72083 33.42892,12.71725 46.14975,0l50.79733,-50.79733c0.69875,-0.69875 1.83467,-0.69875 2.53342,0l5.06683,5.06683c0.69875,0.69875 0.69875,1.83467 0,2.53342l-50.79733,50.79733c-8.45308,8.45667 -19.565,12.685 -30.67692,12.685z"></path></g></g></g></svg>
    }

    sendSVGImage = (imageColor, width, height) => {
        return <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
            // width={width || "100%"} height={height || "100%"}
            viewBox="0 0 172 172"
            style={{ fill: imageColor }}><g fill="none" fillRule="nonzero" stroke="none" strokeWidth="1" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeDasharray="" strokeDashoffset="0" fontFamily="none" fontWeight="none" fontSize="none" textAnchor="none" style={{ mixBlendMode: "normal" }}><path d="M0,172v-172h172v172z" fill="none"></path><g id="original-icon" fill={imageColor}><path d="M10.07813,10.16211l20.24024,65.08789h130.93164zM30.31836,86l-20.24024,65.0459l151.17188,-65.0459z"></path></g></g></svg>
    }

    onRemovePreviewFile = (file)  => {
        let previewFiles = this.state.previewFiles || [];
        previewFiles = previewFiles.filter(previewFile => previewFile.name !== file.name);
        this.setState({previewFiles: previewFiles});
    }

}

export default InputBox;